import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  content: {
    backgroundColor: '#fff',
    position: 'relative',
    maxWidth: '460px',
    padding: '15px',
    borderRadius: '8px',
    fontSize: '16px',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    padding: '44px 24px 24px 24px',
    gap: '19px',
  },
  title: {
    fontWeight: 700,
    fontSize: '20px',
    textAlign: 'center',
  },
  subtitle: {
    display: 'flex',
    flexDirection: 'column',
    gap: '19px',
    color: 'rgba(0, 0, 0, 0.87)',
    textAlign: 'center',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 15px',
    gap: '15px',
  },
  bodyTitle: {
    fontWeight: 700,
  },
  bodyList: {
    padding: '0 15px',
    margin: 0,
  },
  link: {
    color: 'rgba(41, 121, 255, 0.87)',
  },
  button: {
    textTransform: 'uppercase',
  }
}))
